import { ifAuthenticated, ifNotAuthenticated } from '@/utils/authorization.js';
import ChangePassword from '@/views/Auth/ChangePassword.vue';
import Login from '@/views/Auth/Login.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';
import TwoFactorSetup from '@/views/Auth/TwoFactorSetup.vue';

export default [
    // Login
    {
        path: '/login',
        name: 'auth.login',
        component: Login,
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
        },
    },

    // ResetPassword
    {
        path: '/reset-password',
        name: 'auth.reset-password',
        component: ResetPassword,
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
        },
    },

    // ChangePassword
    {
        path: '/change-password/:token',
        name: 'auth.change-password',
        component: ChangePassword,
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
        },
    },

    // 2FA
    {
        path: '/setup-two-factor',
        name: 'auth.twoFactorSetup',
        component: TwoFactorSetup,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: 'auth',
        },
    },
];
